import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { ClaimsForm } from '@modules/hr-workTimes/claim/ClaimsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const claimsUrl = '/metropolis/api/hr/workplan/worktime/claims';
export const claimsLabel = 'Časové položky - nastavení';
export const claimsPath = '/hr/work-times/settings';
export const claimsGridName = 'ClaimsGrid';
export const ClaimsGrid = compose(
  withRouter,
  setDisplayName(claimsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: claimsLabel }]),
  withColumns(Agenda.CLAIMS),
  withProps(({ columns }) => ({
    name: claimsGridName,
    url: claimsUrl,
    Form: ClaimsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.CLAIMS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-workTimes/claim/ClaimsGrid.tsx